import {
  createRouter,
  createWebHashHistory,
  createWebHistory,
} from "vue-router";
// import HomeView from '../views/HomeView.vue'
import store from "@/store";
import { useMessage } from "@/hooks/useMessage";
// 导入进度条插件
import useNProgress from "@/hooks/useNProgress";
const NProgress = useNProgress();

// 页面布局组件
const Layout_mw = () =>
  import(/* webpackChunkName: "layout" */ "@/layout/des_mw.vue");
const Layout_tes = () =>
  import(/* webpackChunkName: "layout" */ "@/layout/des_tes.vue");
const Layout_pvtv = () =>
  import(/* webpackChunkName: "layout" */ "@/layout/pvtv.vue");

// 对于权限管理，刚开始路由只加载，不需要权限的路由、比如：登录、404、这些无关紧要的路由
// 对于这些需要权限的路由，我们需要根据后台返回的权限路由，通过router.addRoute()动态添加进来
const routes = [
  // /主页写在vuex获取loadAsyncRoute()中
  // {
  //   path: "/",
  //   name: "index",
  //   redirect: "/project",
  // },
  // layout des_mw  数字化能源管理平台DEMP
  {
    path: "/des_mw/project",
    name: "layout_mw",
    component: Layout_mw,
    redirect: "/des_mw/project/map",
    children: [],
  },
  {
    path: "/des_mw",
    name: "des_mw",
    component: () => import("@/views/mw_views/projectList.vue"),
  },
  // layout  PVTV
  {
    path: "/pvtv/project",
    name: "layout_pvtv",
    component: Layout_pvtv,
    redirect: "/pvtv/project/map",
    children: [],
  },
  {
    path: "/pvtv",
    name: "pvtv",
    component: () => import("@/views/pvtv_views/projectList.vue"),
  },
  // 所有软件平台platform
  {
    path: "/platform",
    name: "platform",
    component: () => import("@/views/Platform/PlatformList.vue"),
  },
  {
    path: "/login",
    name: "login",
    component: () => import("@/views/Login/Login.vue"),
  },
  // Error
  {
    path: "/:pathMatch(.*)*",
    name: "notFound",
    component: () => import("@/views/Error/404.vue"),
  },
];
// 创建路由
const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

// 全局导航前置守卫
router.beforeEach((to, from, next) => {
  // 开启进度条动画
  NProgress.start();
  const token = store.state.user.token;
  if (to.name !== "login") {
    if (!token) {
      // 返回到登录页
      next({ name: "login" });
    } else {
      // 页面刷新，重新加载权限路由
      if (!store.state.user.isDynamicAddedRoute) {
        store.dispatch("user/loadAsyncRoute").then(() => {
          router.push(to.fullPath);
        });
      } else {
        // 判断/pvtv/project是否携带正确的参数project_id
        if (to.path.includes("/pvtv/project")) {
          if (store.state.project.chooseProject.PROJECT_ID) {
            next();
          } else {
            // 提示用户，请选择项目
            useMessage("请选择项目", "warning");
            next({ name: "pvtv" });
          }
        }
        if (to.path.includes("/des_mw/project")) {
          if (store.state.project.chooseProject.PROJECT_ID) {
            next();
          } else {
            // 提示用户，请选择项目
            useMessage("请选择项目", "warning");
            next({ name: "des_mw" });
          }
        }
        next();
      }
    }
  } else {
    next();
  }
});

// 全局导航后置守卫
router.afterEach(() => {
  // 关闭进度条
  NProgress.done();
});

export default router;
